import { EdgeInsets, Metrics } from './SafeArea.types';

export const initialWindowMetrics: Metrics | null = null;

/**
 * @deprecated
 */
export const initialWindowSafeAreaInsets: EdgeInsets | null = null;
